import { Main, Acl, Entry } from 'Pages'
import { MainSiderWrapper, EmbeddedComponentWrapper } from 'Components'
import GraphView from 'Pages/Explore/RightPanel/GraphView'

{ Login, SignUp } = Entry

export default [{
  component: () -> MainSiderWrapper(Login)
  path: '/login'
  isPublic: true
}, {
  component: () -> MainSiderWrapper(SignUp)
  path: '/signup'
  isPublic: true
}, {
  component: () -> MainSiderWrapper(Acl)
  path: '/acl'
  isPublic: false
}, {
  component: () -> <EmbeddedComponentWrapper Component={GraphView} />
  path: '/:spaceId?/embedded/'
  isPublic: true
}, {
  component: () -> MainSiderWrapper(Main)
  path: '/:spaceId?'
  isPublic: true
}]
